import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f6afbec"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f6afbec')) {
      api.createRecord('6f6afbec', component.options)
    } else {
      api.reload('6f6afbec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6f6afbec", function () {
      api.rerender('6f6afbec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/WeCom/Seminar/Middle/index.vue"
export default component.exports